import { render, staticRenderFns } from "./trans-totals.vue?vue&type=template&id=63ec7022&scoped=true"
import script from "./trans-totals.vue?vue&type=script&lang=js"
export * from "./trans-totals.vue?vue&type=script&lang=js"
import style0 from "./trans-totals.vue?vue&type=style&index=0&id=63ec7022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec7022",
  null
  
)

export default component.exports